import { IS_UXBEAUTY } from 'components/constants/Constants';
import { RegistrationPageFormState, RegistrationPageMode } from './types';
import { SignupInput } from 'api/services/RegistrationService';

export const mapFormStateToSignupPayload = (
  data: RegistrationPageFormState,
  mode: RegistrationPageMode
): SignupInput => {
  const formattedPhoneNumber = formatPhoneNumber(data.phoneNumber);

  return {
    email: data.email,
    password: data.password,
    firstname: data.firstName,
    lastname: data.lastName,
    department: data.function,
    country_code: data.country,
    ...(data.title ? { job_title: data.title } : {}),
    ...(IS_UXBEAUTY
      ? {
          event_terms_accepted: data.tosChecked
        }
      : {
          ...(data.segments.length ? { segments: data.segments } : {}),
          notifications: {
            covalo_digest_enabled: data.notifications.covalo_digest_enabled
          }
        }),
    terms_accepted: data.tosChecked,
    phone_number: formattedPhoneNumber,
    special_case: [
      RegistrationPageMode.COMPANY_REJECTED_MATCH,
      RegistrationPageMode.COMPANY_NO_MATCH
    ].includes(mode)
      ? {
          company_name: data.company,
          user_notes: data.companyNote,
          company_type: data.companyType
        }
      : undefined
  };
};

//we need phone number to be saved in following format (+49)123123213
//luckily miui tel leaves us a space after the country code so we can rely on this by taking the first after splitting by spaces
export const formatPhoneNumber = (phoneNumber: string) => {
  return phoneNumber
    .split(' ')
    .map((x, index) => (index === 0 ? '(' + x + ')' : x))
    .join('');
};
